import Axios, { type AxiosInstance, type AxiosPromise, type AxiosResponse } from 'axios';
import ApiService from './apiService';
import type { ltCommon, ltFramework } from '@life-time-inc/enterprise-framework-core';
import Cookies from 'cookies-js';
import { CookieConstant } from '../constants';
import { featureFlagService, sessionService } from '@life-time-inc/enterprise-framework-core';
import QueryStringParser from '../../lib/helpers/queryStringParser';

export const ProfileServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'user-profile/',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
		'Content-Type': 'application/json; charset=UTF-8'
	}
});

// Define a temp interface here since we're just trying to delete this file asap
interface IOldProfileService {
	getProfile(): AxiosPromise<ltFramework.IProfileResponse>;
	logout(): Promise<AxiosResponse<ltFramework.IProfileLogoutResponse> | void>;
	getCustomerToken(): string;
}

/** @deprecated prefer `enterprise-framework-core` */
class ProfileService extends ApiService implements IOldProfileService {
	constructor() {
		super('profile-service', ProfileServiceAxiosInstance);
	}

	/** @deprecated prefer `enterprise-framework-core` */
	public getProfile(): AxiosPromise<ltFramework.IProfileResponse> {
		const config: ltCommon.IAxiosRequestConfig = { useB2C: featureFlagService.isEnabled('useB2C') };
		return this.axiosInstance.get('profile', config);
	}

	/** @deprecated prefer `enterprise-framework-core` */
	public logout(): AxiosPromise<ltFramework.IProfileLogoutResponse> {
		return this.axiosInstance.delete('profile');
	}

	/** @deprecated prefer `enterprise-framework-core` */
	public getCustomerToken(): string {
		let customerTokenParam: string = QueryStringParser('ct');
		const { ctSupport } = window.lt.pageProperties?.auth || {};
		if (customerTokenParam && ctSupport) {
			sessionService.setCustomerToken(customerTokenParam);
		}
		if (!customerTokenParam) {
			const ctCookie = Cookies.get(CookieConstant.customerToken);
			if (ctSupport && ctCookie) {
				customerTokenParam = ctCookie;
			}
			if (!ctSupport && ctCookie) {
				sessionService.invalidateCustomerToken();
			}
		}
		return customerTokenParam;
	}
}

export const profileService = new ProfileService();
